import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs';
import { LookAndFeelWebView } from 'src/models/LookAndFeelWebView';
import { APIcountryService } from 'src/services/api-services/api-country-service';
import { HelperService } from 'src/services/helperService';
import { HistoryService } from 'src/services/historyService';
import { GetTokenService } from 'src/services/incadea/incadea-services/getToken.service';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';
import { ViewType } from 'src/app/enums/viewType.enum';


@Component({
    selector: 'app-i-banner-manage-service',
    templateUrl: './i-banner-manage-service.component.html',
    styleUrls: ['./i-banner-manage-service.component.sass'],
    standalone: false
})
export class IBannerManageServiceComponent extends PublicSiteConfigBaseComponent implements OnInit {

  brand = {} as LookAndFeelWebView;
  webview = {} as LookAndFeelWebView;
  languageFromParams: string="";
  imagen_banner :any
  styleBanners: string=""
  styleButton: string=""
  token: string =""
  LanguageForCountry:string="es-CO"
  isLoading:boolean = true
  scheduleAppointment: string = ''
  consultantFormUrl= ""
  styleButton2: any=""
  button2={
    "background":this.styleButton2
  }
  nameCountry:string=""
  backEndCode:string = "COL"
  bannerManagementStrong: number = 0
  onlyInchcapeRetail:string = ""
  utmParams=  {
    "UtmSource": "",
    "UtmCampaign": "",
    "UtmMedium": "",
    "UtmContent": "",
    "UtmTerm": ""
  }

  

  constructor(
    private getTokenService: GetTokenService,
    public helperService: HelperService,
    private router: Router,
    private route: ActivatedRoute,
    public navigation: HistoryService,
    public countriesService:APIcountryService,
    private translate: TranslateService,
    public override publicSiteConfig:PublicSiteConfig) 
  {  
    super(publicSiteConfig, ViewType.Incadea);
    translate.setDefaultLang('en-US');
    this.route.params.subscribe(params => {
      this.languageFromParams = params['language'];
      this.indexbrand = params['brand'];
      this.indexCountry = params['country'];
      this.onlyInchcapeRetail = params ['onlyInchcapeRetail'];
    });
    this.bannerManagementStrong = Number(this.indexbrand)
    this.EvaluateBrand();
    this.navigation.startSaveHistory();
  }

  protected override afterConfigLoaded(): void {
    this.imagen_banner = this.CurrentBrand.imagen_banner   
    this.brand = this.CurrentBrand
    this.webview = this.CurrentBrand
    this.styleBanners = this.CurrentBrand.StyleLookAndFeel
    this.styleButton2= this.CurrentBrand.button2
    this.styleButton = this.styleBanners+"button"
    this.button2={
      "background":this.styleButton2
    }
    this.helperService.loginPingId().subscribe({

      next: (token) => {
       
        this.getTokenLoginWebview()
        // Continuar con lógica que depende del token
      },
      error: (error) => {
        console.error('Error al obtener el token:', error);
      },
    });
  }

  getTokenLoginWebview(){
    this.getTokenService.getToken().pipe(tap((responseUserData) => {
      this.token=responseUserData.access_token
      this.getcountry()
    })).subscribe();
  }

  getcountry(){
    this.helperService.countryIdWebView = this.indexCountry
    if (this.languageFromParams) {
      this.LanguageForCountry = this.languageFromParams;
      this.translate.use(this.languageFromParams);
      this.countriesService?.get(this.indexCountry.toString())
      .pipe(
        tap((response) => {
        if (!response.message) {
          this.nameCountry = response.countryName    
          this.isLoading=false
          this.loadBrandTheming()
        }
        else{console.log(response);} 
      })).subscribe({
        error: () => {
          const translateTxtNotMatch = this.translate.instant('notMatchFound');
                this.helperService.showAlert =true
                this.helperService.typeAlert ="error"
                this.helperService.messageAlert =translateTxtNotMatch
              setTimeout(() => {
                this.helperService.showAlert =false
              
                }, 7000)

        }
      });
    }
    else {
      this.countriesService?.get(this.indexCountry.toString()).pipe(tap((response) => {
        if (!response.message) {
          if (response.language) {
            this.LanguageForCountry = response.language;
          }
          this.nameCountry = response.countryName
          this.translate.use(this.LanguageForCountry);
          this.isLoading=false
          this.loadBrandTheming()
        }
        else{console.log(response);} 
      })).subscribe({
        error: () => {
          const translateTxtNotMatch =  this.translate.instant('notMatchFound');
          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =translateTxtNotMatch
        setTimeout(() => {
          this.helperService.showAlert =false
        
          }, 7000)

        }
      });

    }
    
    switch(Number(this.indexCountry)){
      case 3:
        this.backEndCode = "CHL"
      break
      case 5:
        this.backEndCode = "PAN"
      break
      case 6:
        this.backEndCode = "CRI"
      break
      case 8:
        this.backEndCode = "PHL"
      break
    }
  }

  EvaluateBrand() {
    this.scheduleAppointment= `/WebView/i-schedule-choose/${this.indexbrand}/${this.indexCountry}`
    this.consultantFormUrl=`/WebView/i-consultant-appointment/${this.indexbrand}/${this.indexCountry}`
    this.utmEvaluate()

  }

  utmEvaluate(){
    const urlParameters = new URLSearchParams(window.location.search);
    const urlparametes = new URLSearchParams(urlParameters)
    const utm_campaing =  urlparametes.get('utm_campaign')
    const utm_source = urlparametes.get('utm_source');
    const utm_medium = urlparametes.get('utm_medium');
    const utm_content = urlparametes.get('utm_content');
    const utm_term = urlparametes.get('utm_term');
    
    if(utm_campaing){
    this.utmParams.UtmCampaign = `${utm_campaing}`
    }
    if (utm_source) {
      this.utmParams.UtmSource = `${utm_source}`
    }
    if (utm_medium) {
      this.utmParams.UtmMedium = `${utm_medium}`
    }
    if (utm_content) {
      this.utmParams.UtmContent =`${utm_content}`
    }
    if (utm_term) {
      this.utmParams.UtmTerm =`${utm_term}`
    }
    
 
  }

  loadBrandTheming(): void {
    document.documentElement.style.setProperty('--webview-primary-color', this.webview.primaryColor);
    document.documentElement.style.setProperty('--webview-secondary-color', this.webview.secondaryColor);
    document.documentElement.style.setProperty('--webview-tertiary-color', this.webview.tertiaryColor);
    document.documentElement.style.setProperty('--webview-neutral-color', this.webview.neutralColor);
    document.documentElement.style.setProperty('--webview-imagenbanner', this.webview.imagen_banner);
    document.documentElement.style.setProperty('--webview-radius', this.webview.radius);
    document.documentElement.style.setProperty('--webview-radiuscontainer', this.webview.radiuscontainer);
    document.documentElement.style.setProperty('--webview-FontType', this.webview.FontType);
    document.documentElement.style.setProperty('--webview-FontColor', this.webview.FontColor);
    document.documentElement.style.setProperty('--webview-SecundaryFontType', this.webview.SecundaryFontType);
    document.documentElement.style.setProperty('--webview-buttonClear', this.webview.buttonClear);
    document.documentElement.style.setProperty('--webview-buttonClearFontColor', this.webview.buttonClearFontColor);
    document.documentElement.style.setProperty('--webview-buttonClearBorder', this.webview.buttonClearBorder);
    document.documentElement.style.setProperty('--webview-buttonSearch', this.webview.buttonSearch);
    document.documentElement.style.setProperty('--webview-buttonSearchBorder', this.webview.buttonSearchBorder);
    document.documentElement.style.setProperty('--webview-buttonSearchFontColor', this.webview.buttonSearchFontColor);
    document.documentElement.style.setProperty('--webview-buttonBorderColor', this.webview.buttonBorderColor);
    document.documentElement.style.setProperty('--webview-buttonBackgroundColor', this.webview.buttonBackgroundColor);
    document.documentElement.style.setProperty('--webview-fontButtonColor', this.webview.fontButtonColor);
    document.documentElement.style.setProperty('--webview-nextButtonColor', this.webview.nextButtonColor);
    document.documentElement.style.setProperty('--webview-nextButtonFont', this.webview.nextButtonFont);
    document.documentElement.style.setProperty('--webview-backButtonColor', this.webview.backButtonColor);
    document.documentElement.style.setProperty('--webview-backButtonFont', this.webview.backButtonFont);
    document.documentElement.style.setProperty('--webview-cancelBackButtonBackground', this.webview.cancelBackButtonBackground);
    document.documentElement.style.setProperty('--webview-cancelBackButtonText', this.webview.cancelBackButtonText);
    document.documentElement.style.setProperty('--webview-cancelMessageFontType', this.webview.cancelMessageFontType);
    document.documentElement.style.setProperty('--webview-bannerBackgroundColor', this.webview.bannerBackgroundColor);
    document.documentElement.style.setProperty('--webview-bannerBackgroundColorText', this.webview.bannerBackgroundColorText);
    document.documentElement.style.setProperty('--webview-fontTypeCardMyReservation', this.webview.fontTypeCardMyReservation);
  }

}
